/* eslint-disable implicit-arrow-linebreak */
function getPageViewProps() {
  const getVariation = () =>
    document.documentElement.getAttribute('data-tk-catalyst-variant') ?? '';
  const getCategory = () => window?.XO?.metadata?.sid
  const getPricePoint = () => document.querySelector('#price-point .facet-value')?.textContent

  const variation = getVariation();
  const category = getCategory();

  const pricePoint = getPricePoint();

  const pageViewProps = {
    ...{
      categoryName: category,
      subcategoryName: '',
      strategyType: '',
      contentAudienceType: '',
      contentSeries: '',
      productPrice: pricePoint ?? '0',
    },
    ...{
      pageType: '',
      contentTags: '[]',
    },
    ...{ variation: variation ?? '' },
  };

  return pageViewProps;
}

function getCookieValue(name) {
  const regex = new RegExp(`(^| )${name}=([^;]+)`);
  const match = document.cookie.match(regex);
  if (match) {
    return match[2];
  }
  return null;
}

export { getCookieValue, getPageViewProps };
